import { AxiosResponse } from "axios";
import { EDirection, IPageResponse } from "@/services";

export enum ImportStatusEnum {
  PENDING = "PENDING",
  IN_PROGRESS = "IN_PROGRESS",
  UPLOADED = "UPLOADED",
}

export enum ImportTypeEnum {
  SERVICE_POINT = "SERVICE_POINT",
}

export interface ILabelValue<T> {
  label: string;
  value: T;
}

export interface IImportRecord {
  id: number;
  country?: IFileImportCountryResponse;
  requestedBy?: IFileImportUserResponse;
  type?: ImportTypeEnum;
  originalFileName?: string;
  status?: ImportStatusEnum;
  requestedAt?: string;
  createdAt?: string;
  expirationAt?: string;
  progressPercentage?: number;
}

export interface IImportsFilterParams {
  countries?: string[];
  statuses?: ImportStatusEnum[];
  userTypes?: string[];
  usernameOrIdPrecise?: boolean;
  usernameOrId?: string;
  importTypes?: ImportTypeEnum[];
  requestedAt?: string;
  page?: number;
  size?: number;
  orderBy?: string;
  direction?: EDirection;
}

export interface IFileImportService {
  getTemplateFileImportServicepoint(): Promise<AxiosResponse<Blob> | undefined>;
  addMassiveFileImportServicepoint(file: File): Promise<boolean>;
  getImports(params: IImportsFilterParams): Promise<IPageResponse<IImportRecord> | undefined>;
  deleteImport(id: number): Promise<boolean>;
  downloadImport(id: number): Promise<AxiosResponse<Blob> | undefined>;
}

export interface IFileImportServiceMock {
  getTemplateFileImportServicepoint: jest.Mock<Promise<AxiosResponse<Blob> | undefined>>;
  addMassiveFileImportServicepoint: jest.Mock<Promise<boolean>>;
  getImports: jest.Mock<Promise<IPageResponse<IImportRecord> | undefined>>;
  deleteImport: jest.Mock<Promise<boolean>>;
  downloadImport: jest.Mock<Promise<AxiosResponse<Blob> | undefined>>;
}

export interface IFileImportCountryResponse {
  readonly code: string;
  readonly name: string;
}

export interface IFileImportUserResponse {
  readonly id: number;
  readonly name: string;
  readonly email: string;
  readonly username: string;
}
